export default __webpack_public_path__ + "static/media/mobile_4.2a99a0dd.png";